function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M26.2 27v-21c0-1.8-1.4-3.2-3.2-3.2h-1.6c-1.8 0-3.4 1.4-3.4 3.2v2.8l4 4-4 4v9.4",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 47.2c-5 1-10-2-11.6-7-1.6-5.4 1.4-11 6.8-12.6 5.4-1.6 11 1.4 12.6 6.8",
  fill: "none",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.2 41.2c0 1.2-1 2-2 2-1.2 0-2-1-2-2s1-2 2-2 2 1 2 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.6 47.8c0 6.8-5.4 12.2-12.2 12.2-6.8 0-12.2-5.4-12.2-12.2 0-6.8 5.4-12.2 12.2-12.2 6.8 0 12.2 5.6 12.2 12.2z",
  fill: "none",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.6 47.8c0 6.8-5.4 12.2-12.2 12.2-6.8 0-12.2-5.4-12.2-12.2 0-6.8 5.4-12.2 12.2-12.2 6.8 0 12.2 5.6 12.2 12.2z",
  fill: "none",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M31.8 56.4l17.2-17.2",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
})));

var SvgKeyBlocked = function SvgKeyBlocked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKeyBlocked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/key_blocked.9655d3bc.svg";
export { ForwardRef as ReactComponent };